<div class="striped-label" [style.borderLeftColor]="color">
  {{ label }}
</div>
